import { Suspense } from 'react';
import type {
  HypeItErrorCodeType,
  TaskType,
  TeamType,
  UserType,
} from '@api';
import { SearchTableInput, useManageTableContext } from '@common';
import { TasksOverviewTable } from '@features';
import { Box, Group, Skeleton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '../_layout';

type TasksPagePropsType = {
  tasks: TaskType[];
  isPending: boolean;
  error: HypeItErrorCodeType | null;
  assignableUsers: UserType[];
  assignableTeams: TeamType[];
};

export const TasksPage: React.FC<TasksPagePropsType> = ({
  tasks,
  isPending,
  error,
  assignableUsers,
  assignableTeams,
}) => {
  const { t } = useTranslation('tasks');

  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  return (
    <PageLayout title={t('TITLE')}>
      <Box py="md">
        <Group justify="end" mb="xs">
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
            autoFocus
          />
        </Group>
        <Suspense fallback={<Skeleton height={120} />}>
          <TasksOverviewTable
            tasks={tasks}
            isPending={isPending}
            error={error}
            assignableUsers={assignableUsers}
            assignableTeams={assignableTeams}
          />
        </Suspense>
      </Box>
    </PageLayout>
  );
};
